import React, { useEffect, useRef, useState } from "react";
import { Pagination } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import FullPageProgress from "../../components/FullPageProgress";
import { ToastManager } from "../../components/Toast/ToastManager";
import { CheckBox } from "../../icons";
import ExploreFilter from "./ExploreFilter";
import ExploreList from "./ExploreList";
import { EXPLORE_SERVICES } from "../../services";
import "./style.scss";

const Explore = () => {
  const eventTabs = {
    upcoming: "Upcoming",
    replays: "Replay Available",
    "get-notified-of-replays": "Replay Pending",
  };
  const [ToggleState, setToggleState] = useState(["upcoming"]);
  const [loading, setLoading] = useState(false);
  const [textSearch, setTextSearch] = useState("");
  const dataFetchedRef = useRef(false);

  const [listData, setListData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [filter, setFilter] = useState({ page: 1, limit: 20 });

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    setLoading(true);
    let parma = { ...filter, type: ToggleState };
    EXPLORE_SERVICES.list(parma)
      .then(data => {
        if (data.code === 200) {
          setListData(data.data?.list);
          if (data.data?.pageInfo?.page === 1) {
            setTotalPage(data.data?.pageInfo?.totalPage || 0);
          }
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
        dataFetchedRef.current = false;
      });
  }, [filter, ToggleState]);

  const changeTabs = item => {
    if (loading) return;
    setToggleState(old => {
      if (old.includes(item)) {
        return old.filter(i => i !== item);
      } else {
        return [...old, item];
      }
    });
    setFilter(old => ({
      ...old,
      page: 1,
    }));
  };

  useEffect(() => {
    setFilter(old => ({
      ...old,
      page: 1,
      search: textSearch,
    }));
    if (textSearch) {
      dataFetchedRef.current = false;
    }
  }, [textSearch]);

  const handleChangePage = (event, newPage) => {
    if (filter?.page === newPage) return;
    setFilter(old => ({
      ...old,
      page: newPage,
    }));
  };
  return (
    <React.Fragment>
      <div className="events6ix-layout-page-middle">
        <ExploreFilter setTextSearch={setTextSearch} textSearch={textSearch} />

        <div className="event-page-explore-content">
          <div className="events6ix-tabs">
            {Object.keys(eventTabs).map((item, key) => (
              <div
                key={key}
                className={`events6ix-tabs-item ${
                  ToggleState.includes(item) ? "active" : ""
                }`}
                onClick={e => {
                  changeTabs(item);
                }}
              >
                <CheckBox checked={ToggleState.includes(item)} />
                {eventTabs[item]}
              </div>
            ))}
          </div>
          <div className="new-event-page-tabs-data">
            <ExploreList
              loading={loading}
              listData={listData}
              ToggleState={ToggleState}
            />
            {totalPage > 1 && (
              <Flex justify="center" className="text-center mt-20">
                <Pagination
                  variant="text"
                  onChange={handleChangePage}
                  page={filter?.page}
                  count={totalPage}
                />
              </Flex>
            )}
            {loading ? <FullPageProgress fixed={true} /> : null}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Explore;
